<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;margin-top:-5px;"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <Steps :active="eventlist.length" direction="vertical">
                    <Step v-for="(item,index) in eventlist" :key="index">
                        <h3>
                            <span>{{item.eventName}}</span>
                            &nbsp;
                        </h3>
                        <div v-for="(param,index) in item.params" :key="index"
                             style="border: 1px solid #000; display: inline-block;
                                        border-radius: 5px; margin-right: 8px; margin-bottom: 5px; padding: 0 3px                                    ">
                            {{`${param.name} :${param.value}`}}
                        </div>
                        <p>{{item.time}}</p>
                    </Step>
                </Steps>
            </List>
        </PullRefresh>
    </div>
</template>

<script>
    import {List, PullRefresh, Step, Steps} from "vant";

    export default {
        components: {
            Steps,
            Step,
            List,
            PullRefresh
        },
        props: {},
        data() {
            return {
                eventlist: [],
                loading: false,
                isReFresh: false,
                finished: false
            };
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            onLoad(isPullRefresh) {
                this.$http.tokiot.device.event.list({
                    deviceId: this.$route.params.id,
                    size: 20,
                    page: this.eventlist.length / 20 + 1
                })
                    .then(res => {
                        if (res) {
                            res.rows.map(item => item.params = JSON.parse(item.params))
                            this.eventlist.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            // 数据全部加载完成
                            if (this.eventlist.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
            onRefresh() {
                this.isReFresh = true;
                this.eventlist = [];
                this.onLoad(true);
            }
        },
        watch: {}
    };
</script>
